// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Autocomplete } from '@mui/material';
import { CustomIcon } from 'components/CustomIcon';
import { pxToEm } from 'theme';
import { selectSizes } from '../MBSelect/MBSelect.styles';

export const Icon = styled(CustomIcon)`
  pointer-events: none;
  user-select: none;
  display: inline-block;
  flex-shrink: 0;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: ${pxToEm(12)} !important;
  }
`;

export const MBAutocomplete = styled(Autocomplete)`
  .MuiAutocomplete-endAdornment {
    top: calc(50% - 14px);
    right: ${pxToEm(12)};
  }
  .MuiInput-root {
    height: ${(props) =>
      props.size != null ? selectSizes.height[props.size] : 'auto'};
    border-radius: 8px;
  }
  .MuiInput-underline.Mui-focused:after {
    border-color: ${({ theme }) => theme.palette.grey[800]}!important;
  }
`;
